import React from "react";
import {Icon} from '../createSvg'
import {IconProps} from "../types";

export const Postback = (props: IconProps) => {
    return (
        <Icon {...props}>
            <path
                d="m21.65 7.65-2.79-2.79c-.32-.32-.86-.1-.86.35v1.79h-14c-.55 0-1 .45-1 1s.45 1 1 1h14v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.19.2-.51.01-.7z"/>
            <path
                d="m2.35001 16.35 2.79 2.79c.32.32.86.1.86-.35v-1.79h13.99999c.55 0 1-.45 1-1s-.45-1-1-1h-13.99999v-1.79c0-.45-.54-.67-.85-.35l-2.79 2.79c-.2.19-.2.51-.01.7z"/>
        </Icon>
    )
}

